import { Injectable, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';

import { startWith } from 'rxjs/operators';

import { TellentAppsDataFacade } from '@core/tellent-logic';
import { SeatKind, TellentRole } from '@core/tellent-types';

import type { SeatType } from './access-roles-table.component';

@Injectable({ providedIn: 'root' })
export class AccessRolesTableService {
  constructor(
    private apps: TellentAppsDataFacade,
    private destroyRef: DestroyRef,
  ) {}

  public bindSeatLogic(seatKind: SeatKind, seatFormGroup: FormGroup<SeatType>) {
    const toggleCtrl = seatFormGroup.controls.toggle;
    const roleCtrl = seatFormGroup.controls.roleExternalId;

    toggleCtrl.valueChanges
      .pipe(startWith(toggleCtrl.value), takeUntilDestroyed(this.destroyRef))
      .subscribe(isOn => {
        const defaultRole: TellentRole | null = this.apps.defaultRoleBySeatKind(seatKind)() ?? null;

        if (isOn === false) {
          // Only disable when explicitly false, not null
          // OFF → clear & disable
          roleCtrl.setValue(null, { emitEvent: false });
          roleCtrl.disable({ emitEvent: false });
        } else if (isOn === true) {
          // ON  → enable & maybe seed default
          roleCtrl.enable({ emitEvent: false });
          if (!roleCtrl.value && defaultRole?.externalId) {
            roleCtrl.setValue(defaultRole.externalId, { emitEvent: false });
          }
        }
        // Do nothing when isOn === null (initial state)
      });
  }
}
